import React, { forwardRef } from 'react'

import { css } from '@emotion/react'
import DOMPurify from 'isomorphic-dompurify'
import { marked } from 'marked'

import type { IProps } from './types'

marked.setOptions({})

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  if ('target' in node) {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener')
  }
})

export const Markdown = forwardRef<HTMLDivElement, IProps>(
  ({ children = '', ...props }, ref) => {
    return (
      <div
        ref={ref}
        css={css`
          p:last-child {
            margin-bottom: 0;
          }
        `}
        dangerouslySetInnerHTML={{
          __html: marked(DOMPurify.sanitize(children)),
        }}
        {...props}
      />
    )
  },
)

export default Markdown
